export enum SummarizerTypeEnum {
  TLDR = 'tldr',
  Teaser = 'teaser',
  KeyPoints = 'key-points',
  Headline = 'headline',
}
